/*
 * isNumber Validation
 * isNumber checks to see if the value is a number
 * isNumberValidation returns the DEFAULT_MESSAGE if no numbers were found
 */
export const DEFAULT_MESSAGE = 'Number required';

function isNumber(value) {
    return /^[0-9]+$/g.test(value);
}

export function isNumberValidation() {
    const errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_MESSAGE;
    return function error(value) {
        return !isNumber(value) ? errorMessage : undefined;
    };
}

export default isNumber;
